export const CURRENCIES = {
    USD: {symbol: "$", before: true},
    EUR: {symbol: "€", before: true},
    GBP: {symbol: "£", before: true},
};

